<template>
  <v-list
      :label="menu.properties.label + '_ddm'"
      :id="menu.properties.id + '_ddm'"
  >
    <template v-for="(menuItem, index) in menu.items">
      <v-list-group
          :key="index"
          v-if="menuItem.visible && menuItem.items && menuItem.items.length > 0"
      >
        <template v-slot:activator>
          <v-list-item-title>
            <a
                :href="menuItem.route ? menuItem.route.url : '#'"
                :target="menuItem.route ? menuItem.route.target : null"
                :class="{'active': isActiveMenu(menuItem) }"
                @click="navigate(menuItem, $event)"
                :label="menuItem.properties.label"
                :id="menuItem.properties.id"
            >
              {{ menuItem.properties.label }}
            </a>
          </v-list-item-title>
        </template>
        <template v-slot:appendIcon>
          <v-icon>
            mdi-chevron-down
          </v-icon>
        </template>

        <dynamic-menu
            :mobile="mobile"
            :level="level+1"
            class="ml-4"
            :context="menuItem"
            :navigate="navigate"
        />
      </v-list-group>
      <v-list-item
          v-else-if="menuItem.visible"
          link
          append
          exact
          exact-path
          :key="index"
          v-bind="menuItem.properties"
      >
        <v-list-item-title
            v-if="menuItem.properties.label"
        >
          <a
              :class="{'active': isActiveMenu(menuItem) }"
              :href="getURLLocalGlobal(menuItem.route ? menuItem.route.url : '#')"
              :target="menuItem.route ? menuItem.route.target : null"
              @click="navigate(menuItem, $event)"
              :label="menuItem.properties.label"
              :id="menuItem.properties.id"
          >
            {{ menuItem.properties.label }}
          </a>
        </v-list-item-title>

        <v-list-item-icon
            v-if="menuItem.icon"
        >
          <v-icon
              v-bind="menuItem.icon.properties"
          >{{ menuItem.icon.value }}
          </v-icon>
        </v-list-item-icon>

      </v-list-item>
    </template>

  </v-list>
</template>

<script>

import globalMixins from "@/mixins/globalMixins";

export default {
  name: 'DynamicMenu',

  mixins: [ globalMixins ],

  data() {
    return {
      menu: {
        icon: {},
        properties: {},
        items: []
      }
    }
  },

  props: {
    context: {
      type: Object
    },
    ready: {
      type: Boolean
    },
    navigate: {
      type: Function
    },
    level: {
      type: Number
    },
    mobile: {
      type: Boolean
    }
  },

  async created() {
    this.setMenu();
  },

  methods: {
    async setMenu() {
      this.menu = this._.cloneDeep( this.context );
      this.$forceUpdate();
    }
  },

  watch: {
    async 'ready'( to ) {
      if ( to ) {
        this.setMenu();
      }
    }
  }

};
</script>
